import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import x from '../../assets/icons/close.svg'
import photo from '../../assets/icons/phot.svg'
import addPackage from '../../apis/addPackage'

const AddPackage = ({ cardId, active, close, refresh }) => {
  const popupref = useRef(null)
  const [error, setError] = useState('')
  const [packageData, setPackageData] = useState({
    title: '',
    quantity: '',
    cardId: cardId || '',
    serialNumber: '',
    isActive: 1,
    outOfStock: 0,
    pricePosClient: '',
    pricePosClientOffer: '',
    priceClient: '',
    priceClientOffer: '',
    maxNumberToBuyAtOnce: '',
    discountClient: false,
    discountPos: false,
  })

  const [imageFile, setImageFile] = useState(null)
  const [preview, setPreview] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleAddPackage = async (e) => {
    e.preventDefault()

    const formData = new FormData()
    formData.append('title', packageData.title)
    if (isNaN(packageData.quantity)) {
      setError('quantity should be a number')
      return
    }
    if (isNaN(packageData.maxNumberToBuyAtOnce)) {
      setError('max number to buy should be a number')
      return
    }

    if (
      isNaN(packageData.priceClient) ||
      isNaN(packageData.priceClientOffer) ||
      isNaN(packageData.pricePosClient) ||
      isNaN(packageData.pricePosClientOffer)
    ) {
      setError('price should be a number')
      return
    }
    formData.append('count', packageData.quantity)
    formData.append('card_id', packageData.cardId)
    formData.append('is_active', packageData.isActive)
    formData.append('out_of_stock', packageData.outOfStock)
    formData.append('serial_number', packageData.serialNumber)
    console.log(packageData)
    if (+packageData.maxNumberToBuyAtOnce > +packageData.quantity) {
      setError('the max number should be less than quantity')
      return
    }

    formData.append(
      'max_number_to_buy_at_once',
      packageData.maxNumberToBuyAtOnce
    )

    formData.append('price_client', packageData.priceClient)
    if (packageData.discountClient) {
      formData.append('price_client_offers', packageData.priceClientOffer)
    }

    formData.append('price_pos_client', packageData.pricePosClient)

    if (packageData.discountPos) {
      formData.append('price_pos_offers', packageData.pricePosClientOffer)
    }

    if (imageFile) {
      formData.append('images', imageFile)
    } else {
      setError('Add an Image')
      return
    }

    try {
      setLoading(true)
      await addPackage(cardId, formData)
      refresh()
      close()
    } catch (error) {
      console.log('error', error)
      setError(error.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setPackageData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }))
    setError('')
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    setImageFile(file)
    setPreview(URL.createObjectURL(file))
    setError('')
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    const file = e.dataTransfer.files[0]
    setImageFile(file)
    setPreview(URL.createObjectURL(file))
    setError('')
  }

  const clearFiles = (e) => {
    e.preventDefault()
    setPreview(null)
    setImageFile(null)
    setError('')
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [popupref, close])

  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [active])

  return (
    <motion.div
      className="fixed inset-0 bg-overlay/30 w-screen z-40 h-screen grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        ref={popupref}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className="w-1/2 min-h-10 overflow-hidden bg-white rounded-lg flex flex-col justify-center items-center"
      >
        <form onSubmit={handleAddPackage} className="w-full">
          <div className="w-full px-8 py-5 flex flex-col gap-8">
            <div className="flex border-b-[1px] pb-4 justify-between border-b-darkBlue w-full">
              <div>Add New Package</div>
              <img src={x} onClick={close} className="cursor-pointer" alt="" />
            </div>
            <div className="flex gap-4 justify-center items-stretch">
              <div className="w-1/2 flex flex-col gap-4 h-full">
                <div className="rounded-xl p-4 border-[1px] h-1/3 border-b-darkBlue">
                  <label
                    htmlFor="image"
                    className="w-full cursor-pointer rounded-xl relative p-4"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <input
                      name="image"
                      id="image"
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      className="hidden w-full focus:outline-none"
                    />
                    {preview ? (
                      <div className="w-full absolute top-2 right-2 z-10 flex justify-end items-center">
                        <img
                          onClick={clearFiles}
                          className="cursor-pointer"
                          src={x}
                          alt=""
                        />
                      </div>
                    ) : (
                      <div className="flex w-full justify-center items-center">
                        Choose or Drop a File
                      </div>
                    )}
                    <img
                      src={preview || photo}
                      alt="Preview"
                      className="w-full h-28 object-contain"
                    />
                  </label>
                </div>
                <div>
                  <label>Package Title</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      name="title"
                      placeholder="Package Title"
                      value={packageData.title}
                      onChange={handleInputChange}
                      required
                      className="w-full focus:outline-none"
                    />
                  </div>
                </div>

                <div>
                  <label>Package Quantity</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      value={packageData.quantity}
                      required
                      onChange={handleInputChange}
                      className="w-full focus:outline-none"
                      placeholder="Quantity"
                      name="quantity"
                      id="quantity"
                    />
                  </div>
                </div>
                <div>
                  <label>Max Number To Buy at Once</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      value={packageData.maxNumberToBuyAtOnce}
                      required
                      onChange={handleInputChange}
                      className="w-full focus:outline-none"
                      placeholder="Max Number To Buy at Once"
                      name="maxNumberToBuyAtOnce"
                      id="maxNumberToBuyAtOnce"
                    />
                  </div>
                </div>
              </div>
              <div className="w-1/2 flex flex-col gap-4 h-full">
                <div>
                  <label>Serial Number</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      name="serialNumber"
                      placeholder="Serial Number"
                      value={packageData.serialNumber}
                      onChange={handleInputChange}
                      required
                      className="w-full focus:outline-none"
                    />
                  </div>
                </div>
                <div>
                  <label>Price for Normal User</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      name="priceClient"
                      placeholder="Price"
                      value={packageData.priceClient}
                      onChange={handleInputChange}
                      className="w-full focus:outline-none"
                    />
                  </div>
                  <label>
                    <input
                      type="checkbox"
                      name="discountClient"
                      checked={packageData.discountClient}
                      onChange={handleInputChange}
                      className="mr-2"
                    />
                    Add Discount?
                  </label>
                  {packageData.discountClient && (
                    <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                      <input
                        name="priceClientOffer"
                        placeholder="Discounted Price"
                        value={packageData.priceClientOffer}
                        onChange={handleInputChange}
                        className="w-full focus:outline-none"
                      />
                    </div>
                  )}
                </div>
                <div>
                  <label>Price for Wholesaler</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      name="pricePosClient"
                      placeholder="Price"
                      value={packageData.pricePosClient}
                      onChange={handleInputChange}
                      className="w-full focus:outline-none"
                    />
                  </div>
                  <label>
                    <input
                      type="checkbox"
                      name="discountPos"
                      checked={packageData.discountPos}
                      onChange={handleInputChange}
                      className="mr-2"
                    />
                    Add Discount?
                  </label>
                  {packageData.discountPos && (
                    <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                      <input
                        name="pricePosClientOffer"
                        placeholder="Discounted Price"
                        value={packageData.pricePosClientOffer}
                        onChange={handleInputChange}
                        className="w-full focus:outline-none"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {error && (
            <div className=" w-full flex justify-center py-3 items-center">
              <span className=" bg-red/20 px-3 py-1 text-red rounded">
                {error}
              </span>
            </div>
          )}
          <button
            disabled={loading}
            className="disabled:bg-darkBlue/50 bg-blueButton text-white p-4 w-full rounded"
          >
            {loading ? 'Adding...' : 'Add'}
          </button>
        </form>
      </motion.div>
    </motion.div>
  )
}

export default AddPackage
